import React from 'react'
import ReactDOM from 'react-dom/client'
import '../src/css/styles.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import NormalizePath from './NormalizePath'
/**
 * Creates a new instance of React Query Client.
 * Used for managing server-state caching and fetching in the app.
 */
import { QueryClient, QueryClientProvider } from 'react-query'
/**
 * The root DOM node where the React app is mounted.
 * Uses React 18's `createRoot` API for concurrent rendering.
 */
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const queryClient = new QueryClient()
/**
 * Renders the main application within:
 * - React.StrictMode for highlighting potential issues.
 * - Redux Provider for state management.
 * - React Router for client-side routing.
 * - React Query Client Provider for efficient data fetching and caching.
 * - ToastContainer for showing notifications.
 */
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <NormalizePath />
                <QueryClientProvider client={queryClient}>
                    <ToastContainer hideProgressBar={true} />
                    <App />
                </QueryClientProvider>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>
)
/**
 * Measures app performance and logs results.
 * To enable, pass a function (e.g., `reportWebVitals(console.log)`) or send metrics to an analytics service.
 * Learn more: https://bit.ly/CRA-vitals
 */
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
